import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  input: {
    height: 86,
  },
  passwordEdit: {
    cursor: "pointer",
  },
  cameraSpecificities: {
    height: "22px",
  },
  gridPaddingOverRide: {
    padding: "0 15px",
  },
  item: {
    padding: "0 15px",
    marginBottom: 0,
  },
}));

export default useStyles;
